import { withTheme } from 'styled-components';
import ClickAndReserve from './ClickAndReserve';
export default withTheme(ClickAndReserve);
